<template>
  <div>
    <el-breadcrumb class="breadcrumb-con" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item><a style="color:#fff; font-weight: 600;">{{formatMessage({id:'5g.message.h5.common.name.title',defaultMessage:'5G消息助手'})}}</a></el-breadcrumb-item>
      <!-- <el-breadcrumb-item>机器人</el-breadcrumb-item> -->
    </el-breadcrumb>

    <div class="tab-content-con">
      
      <ul v-show="activeIndex == 0 && chatbotList && chatbotList.length > 0" class="list-con">
        <li v-for="item in chatbotList" tid="maapCode" style="list-style: none">
          <div type="chatbotItem" class="chatbot-item" v-on:click="toChatRoom(item)">
            <el-image v-if="item.logo" class="header-image" :src="item.logo" fit="cover">
            </el-image>
            <img v-else class="header-image" src="../assets/robot.png" />
            <div class="list-text-con">
              <span class="list-title">{{item.name}}</span>
              <span v-if="item.latestMessage" class="list-text">{{item.latestMessage}}</span>
            </div>
            <div class="time-text" v-if="item.latestMessage">
              <span v-bind:class="{ 
                'spot-red' : item.hasUnReadMessage,
                'spot-white': !item.hasUnReadMessage
              }"></span>
              <div>{{getTime(item.latestTime)}}</div>
            </div>
          </div>
        </li>
      </ul>

      <div v-show="activeIndex == 0 && chatbotList.length == 0"  class="list-con" style="flex-direction: column;text-align: center">
        <img style="width: 80%" src="../assets/empty.png" />
        <div class="empty-text">{{formatMessage({id:'5g.message.h5.tipmsg.msg7',defaultMessage:'您当前暂无聊天信息'})}}</div>
        <div class="empty-text">{{formatMessage({id:'5g.message.h5.tipmsg.msg8',defaultMessage:'快去机器人列表看看吧！'})}}</div>
      </div>
      

      <ul v-show="activeIndex == 1" class="list-con" style="padding-top:40px">
        <div class="top-search">
          <el-input :placeholder="formatMessage({id:'5g.message.h5.common.name.chatbot',defaultMessage:'机器人名称'})" prefix-icon="el-icon-search" clearable
            v-model="searchText" >
          </el-input>
        </div>
      
        <li v-for="item in filterList" tid="maapCode" style="list-style: none">
          <div type="chatbotItem" class="chatbot-item" v-on:click="toChatRoom(item)">
            <el-image v-if="item.logo" class="header-image" :src="item.logo" fit="cover">
            </el-image>
            <img v-else class="header-image" src="../assets/robot.png" />
            <div class="list-text-con">
              <span class="list-title">{{item.name}}</span>
              <span class="list-text">{{item.maapServiceNo}}</span>
            </div>
            <div class="time-text">
              <img v-if="item.careChatbotCode" @click="(evt) => unsubscribe(item, evt)" class="icon" src="../assets/care.png" />
              <img v-else class="icon" @click="(evt) => subscribe(item, evt)" src="../assets/un_care.png" />
            </div>
          </div>
        </li>
      </ul>

      <div v-show="activeIndex == 2" >
        <div class="mine_div">
          <img class="mine_icon" src="../assets/user.png" />
          <div class="mine_text">{{mobileNo}}</div>
        </div>
        <div class="mine_div" @click="toggleShowCare">
          <img class="mine_icon" src="../assets/care.png" />
          <div class="mine_text">{{formatMessage({id:'5g.message.h5.common.name.mycoll',defaultMessage:'我的关注'})}}</div>
          <img v-if="showCareList" class="mine_icon" style="float: right" src="../assets/down.png" />
          <img v-else class="mine_icon" style="float: right" src="../assets/right.png" />
        </div>

        <ul  v-show="showCareList" class="list-con" style="padding-bottom:36px">
          <li v-for="item in subscribeChatbot" tid="maapCode" style="list-style: none">
            <div type="chatbotItem" class="chatbot-item" v-on:click="toChatRoom(item)">
              <el-image v-if="item.logo" class="header-image" :src="item.logo" fit="cover">
              </el-image>
              <img v-else class="header-image" src="../assets/robot.png" />
              <div class="list-text-con">
                <span class="list-title">{{item.name}}</span>
                <span class="list-text">{{item.maapServiceNo}}</span>
              </div>
            </div>
          </li>
        </ul>

        <div class="bottom-btn">
          <el-button class="block-btn" v-on:click="handleLogout">{{formatMessage({id:'5g.message.h5.common.name.logout',defaultMessage:'退出登录'})}}</el-button>
        </div>
      </div>
    </div>

    <div class="bottom-menu">
      <div class="bottom-menu-con" @click="changeActive(0)">
        <img v-if="activeIndex == 0" class="bottom-menu-icon" src="../assets/message_a.png" />
        <img v-else class="bottom-menu-icon" src="../assets/message.png" />
        <div class="bottom-menu-text">{{formatMessage({id:'5g.message.h5.common.name.msg',defaultMessage:'消息'})}}</div>
      </div>
      <div class="bottom-menu-con" @click="changeActive(1)">
        <img v-if="activeIndex == 1" class="bottom-menu-icon" src="../assets/list_a.png" />
        <img v-else class="bottom-menu-icon" src="../assets/list.png" />
        <div class="bottom-menu-text">{{formatMessage({id:'5g.message.h5.common.name.chatbot',defaultMessage:'机器人'})}}</div>
      </div>
      <div class="bottom-menu-con" @click="changeActive(2)">
        <img v-if="activeIndex == 2" class="bottom-menu-icon" src="../assets/mine_a.png" />
        <img v-else class="bottom-menu-icon" src="../assets/mine.png" />
        <div class="bottom-menu-text">{{formatMessage({id:'5g.message.h5.common.name.my',defaultMessage:'我的'})}}</div>
      </div>
    </div>
    
  </div>
</template>

<script>
import { addCareChatbot, cancelCareChatbot, createFictitiousPhone } from '../services'
import moment from 'moment'
import qs from 'qs'
import { getParams } from '../utils'
import { encode, decode } from 'js-base64'
import{ mapState, mapMutations, mapActions }from'vuex';

let app;

export default {
  name: 'ChatbotList',
  computed: {
    ...mapState({
      chatbotList: state=>state.chatbotList.chatbotList,
      allChatbot: state=>state.chatbotList.allChatbot,
      subscribeChatbot: state=>state.chatbotList.subscribeChatbot
    }),
    filterList(){
      const allChatbot = this.allChatbot;
      const name = this.searchText;
      const newData = allChatbot.filter(item=> item.name && item.name.indexOf(name) > -1);
      // console.log('过滤机器人列表', newData)
      return newData;
    }
  },
  data () {
    return {
      mobileNo: '',
      activeIndex: 0,
      searchText: '',
      inputInterval: null,
      showCareList: false,
    }
  },

  methods: {
    ...mapMutations('chatbotList', ['setChatbotList']),
    ...mapActions('chatbotList', ['queryList','queryCareList']),
    ...mapMutations('chatRoom',['setState']),

    handleCommand(command){
      this.$router.push('/login')
    },

    changeActive(index){
      this.activeIndex = index;
    },

    toggleShowCare(){
      this.showCareList = !this.showCareList;
    },

    handleLogout(){
      const app = this.$parent;
      if(app.socket){
        console.log('注销 断开websocket')
        app.socket.closeSocket();
      }
      localStorage.setItem('mobileNoLoginStatus', false);
      this.$router.push('/login')
    },

    closeSocket(){
      if(app.socket){
        console.log('注销 断开websocket')
        app.socket.closeSocket();
      }
    },

    getTime(time){
      const chatDate = moment(time).format('YYYY-MM-DD');
      const today = moment().format('YYYY-MM-DD');
      if(chatDate == today){
        return moment(time).format('HH:mm')
      }
      return moment(time).format('MM-DD')
    },

    toChatRoom(chatbot){
      this.closeSocket();
      console.log('chatbot', chatbot)
      const { maapServiceNo, channelCode, hasUnReadMessage, messageContent, 
        apiUrl, websocketUrl
      } = chatbot || {};
      const findout = this.allChatbot.find(item => item.maapServiceNo == maapServiceNo) || {};
      console.log('this.findout', findout)
      this.setState({ 
        apiUrl: findout && findout.apiUrl || apiUrl, 
        websocketUrl: findout && findout.websocketUrl || websocketUrl });
      const mobileNo = this.mobileNo;
      const thisChatbotIndex = this.chatbotList.findIndex(item=> item.maapServiceNo == maapServiceNo);
      if(thisChatbotIndex > -1){
        this.chatbotList[thisChatbotIndex].hasUnReadMessage = false;
      }
      this.setChatbotList([...this.chatbotList]);
      if(hasUnReadMessage && messageContent){
        const recordList = localStorage.getItem(`${maapServiceNo}+${mobileNo}+recordList`);
        let dataList = [];
        if (recordList) {
          try {
            dataList = JSON.parse(recordList) || [];
            dataList.push(messageContent);
          } catch (err) {
            dataList.push(messageContent)
          }
        } 
        console.log('聊天缓存')
        const recordListString = JSON.stringify(dataList);
        localStorage.setItem(`${maapServiceNo}+${mobileNo}+recordList`, recordListString);
      }
      const params = JSON.stringify({ 
        mobileNo: mobileNo, 
        serviceNo: maapServiceNo,
        channelCode
      })
      localStorage.setItem('urlActionNeedReply', false); // 控制是否正常下发
      this.$router.push(`/chatRoom?param=${encode(params)}`)
    },

    queryAllChatbot(){
      this.queryList({mobileNo: this.mobileNo})
    },

    getChatbotList(){
      const chatbotList = localStorage.getItem(`chatbotList+${this.mobileNo}`);
      if(chatbotList){
        const dataList = JSON.parse(chatbotList)
        // console.log('localStorage.getItem robotLists', dataList)
        if (dataList.length > 0) {
          this.setChatbotList(dataList)
        }
      }
    },

    subscribe(chatbot, evt){
      // console.info('关注机器人', evt, chatbot)
      evt.stopPropagation();
      const params = {
        mobileNo: this.mobileNo,
        maapCode: chatbot.maapCode
      };
      const _this = this;
      addCareChatbot(params).then(response=>{
        if(response && response.success){
          _this.$message({
            message: _this.formatMessage({id:'5g.message.h5.tipmsg.msg9',defaultMessage:'关注成功！'}),
            type: 'success'
          });
          _this.queryCareList({mobileNo: _this.mobileNo});
        } else {
          _this.$message({
            message: _this.formatMessage({id:'5g.message.h5.tipmsg.msg10',defaultMessage:'关注失败！'}),
            type: 'error'
          });
        }
      })
    },

    unsubscribe(chatbot, evt){
      // console.info('取消关注', evt, chatbot)
      evt.stopPropagation();
      const _this = this;
      cancelCareChatbot(chatbot.careChatbotCode).then(response=>{
        if(response && response.success){
          _this.$message({
            message: _this.formatMessage({id:'5g.message.h5.tipmsg.msg11',defaultMessage:'取消成功！'}),
            type: 'success'
          });
          _this.queryCareList({mobileNo: _this.mobileNo});
        } else {
          _this.$message({
            message: _this.formatMessage({id:'5g.message.h5.tipmsg.msg12',defaultMessage:'取消失败！'}),
            type: 'error'
          });
        }
      })
    },

  },

  created(){
    const _this = this;
    app = this.$parent;
    const mobileNo = localStorage.getItem('mobileNo');
    console.log('this.$route', this.$route);
    const pathname = window.location.pathname;
    let reg  = /\/m\/(\d+)\//;
    
    const { params, query } = this.$route;
    let { templateId, platformCode } = params;
    if(reg.test(pathname)){
      let url = pathname.replace('/m/','');
      templateId = url.substr(0,url.indexOf('/'));
      platformCode = url.substr(url.indexOf('/')+1);
    }
    console.log('templateId, platformCode：',templateId, platformCode);
    this.setState({ queryParams: query }); 
    
    if(templateId){
      this.closeSocket();
      createFictitiousPhone({
        templateId, mobileNo, platformCode
      }).then(response=>{
        if(response && response.success){
          const { phone, serviceNo, templateCode, apiUrl, websocketUrl, postbackData } = response.data;
          let napiUrl = apiUrl;
          let nwebsocketUrl = websocketUrl;
          if(napiUrl.lastIndexOf('/')==napiUrl.length-1){
              napiUrl = napiUrl.substr(0,napiUrl.length-1);
          }
          if(nwebsocketUrl.lastIndexOf('/')==nwebsocketUrl.length-1){
              nwebsocketUrl = nwebsocketUrl.substr(0,nwebsocketUrl.length-1);
          }
          _this.setState({ apiUrl:napiUrl, websocketUrl:nwebsocketUrl })
          const param = JSON.stringify({
            serviceNo, mobileNo: mobileNo || phone,
            reply: templateCode ? {
                displayText: "",
                postback: {
                    data: postbackData || `##########0########${templateCode}**`
                }
            } : undefined,
            contentType: "reply"
          })
          _this.$router.replace(`/chatRoom?param=${encode(param)}`)
        }
      })
    } else {
      const status = localStorage.getItem('mobileNoLoginStatus');
      if(mobileNo && status == 'true'){
        this.mobileNo = mobileNo;
        this.getChatbotList();
        this.queryAllChatbot();

      } else {
        this.$router.replace('/login')
      }
    }
  },

  mounted(){
  },

  beforeDestroy(){
    localStorage.setItem(`chatbotList+${this.mobileNo}`, JSON.stringify(this.chatbotList));
  }
}
</script>

<style lang="less" scoped>
  @import './styles.less';
  
</style>


// WEBPACK FOOTER //
// src/chatbotList/index.vue